import { CianSmall12 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { onlyCianSelector } from './selectors';
import { trackModalOpen } from './tracking';
import { FloatingLabel } from '../../components/FloatingLabel';

const HOW_IT_WORKS_LINK = 'https://www.cian.ru/legal-documents/tolko_na_cian_0';

export function OnlyCianLabelNewContainer() {
  const isUnique = useSelector(onlyCianSelector);
  const handleTooltipOpen = React.useCallback(() => trackModalOpen(), []);

  if (!isUnique) {
    return null;
  }

  return (
    <FloatingLabel
      labelText="Только на Циан"
      tooltipTitle="Только на Циан"
      tooltipText="За последние сутки мы не нашли этот объект в открытом доступе на других агрегаторах"
      color="primary_100"
      backgroundColor="primary_10"
      icon={<CianSmall12 color="primary_100" />}
      link={HOW_IT_WORKS_LINK}
      onOpen={handleTooltipOpen}
    />
  );
}
